const TWO_SECOND = 2000;

class AppDebugger {
  /** @type {"disabled"|"enabled"} */
  state = "disabled";
  babyRtcManager;
  parentRtcManagers;
  /** @type {HTMLDivElement} */
  overlay;
  interval;

  enable = () => {
    this.state = "enabled";
    if (!this.overlay) this.createOverlay();
    this.overlay.innerHTML = "No RTC information found";
  };

  disable = () => {
    this.state = "disabled";
    if (this.overlay) {
      this.overlay.remove();
      this.overlay = null;
    }
    if (this.interval) this.clear();
  };

  clear = () => {
    clearInterval(this.interval);
    this.interval = null;
  };

  startBabyDebug = () => {
    if (this.interval) this.clear();

    this.interval = setInterval(() => {
      if (!this.babyRtcManager) {
        this.overlay.innerHTML = "No RTC information found";
        return;
      }
      const { messenger, videoStream, videoTrack, peers } = this.babyRtcManager;

      const peerConnections = this.getBaseRtcStats(peers);

      const data = {
        presence: messenger?.presence,
        videoStream: "",
        "- active": videoStream?.active,
        videoTrack: "",
        "- kind": videoTrack?.kind,
        "- label": videoTrack?.label,
        "- muted": videoTrack?.muted,
        "- readyState": videoTrack?.readyState,
        peers: "",
        ...peerConnections
      };

      const statsString = Object.entries(data)
        .map((entry) => {
          const [key, val] = entry;
          return `${key}: ${val} <br/>`;
        })
        .join("");

      this.overlay.innerHTML = statsString;
    }, TWO_SECOND);
  };

  startParentDebug = () => {
    if (this.interval) this.clear();

    this.interval = setInterval(() => {
      if (!this.parentRtcManagers) {
        this.overlay.innerHTML = "No RTC information found";
        return;
      }
      const stationInfo = {
        presence: "",
        peers: ""
      };

      const peers = Object.values(this.parentRtcManagers).reduce(
        (acc, rtcManager) => {
          const { messenger, peers } = rtcManager;

          const peerConnections = this.getBaseRtcStats(peers);

          stationInfo.presence = messenger.presence;
          const pcStatsString = Object.entries(peerConnections)
            .map((entry) => {
              const [key, val] = entry;
              return `${key}: ${val} <br/>`;
            })
            .join("");

          acc += pcStatsString;
          return acc;
        },
        ""
      );

      let statsString = Object.entries(stationInfo)
        .map((entry) => {
          const [key, val] = entry;
          return `${key}: ${val} <br/>`;
        })
        .join("");
      statsString += peers;

      this.overlay.innerHTML = statsString;
    }, TWO_SECOND);
  };

  createOverlay = () => {
    const overlay = document.createElement("div");
    overlay.style.cssText =
      "position:fixed; top:83px; left:12px; padding:16px; background-color:rgba(0, 0, 0, 0.4); pointer-events:none; z-index:99999; color:white; border-radius:16px;";
    this.overlay = overlay;
    document.body.appendChild(overlay);
  };

  getBaseRtcStats = (obj) => {
    return Object.values(obj).reduce((acc, val) => {
      if (val.jid) {
        acc.jid = val.jid;
      }
      if (val.networkType) {
        acc["- networkType"] = val.networkType;
      }
      if (val.peerConnection?.connectionState) {
        acc["- connectionState"] = val.peerConnection.connectionState;
      }
      if (val.peerConnection?.iceConnectionState) {
        acc["- iceConnectionState"] = val.peerConnection.iceConnectionState;
      }
      if (val.peerConnection?.iceGatheringState) {
        acc["- iceGatheringState"] = val.peerConnection.iceGatheringState;
      }
      if (val.peerConnection?.signalingState) {
        acc["- signalingState"] = val.peerConnection.signalingState;
      }
      if (val.videoQualitySettings) {
        acc.videoQualitySettings = "";
      }
      if (val.videoQualitySettings?.onCellular) {
        acc["- onCellular"] = val.videoQualitySettings.onCellular;
      }
      if (val.videoQualitySettings?.onWifi) {
        acc["- onWifi"] = val.videoQualitySettings.onWifi;
      }
      return acc;
    }, {});
  };
}

const appDebugger = new AppDebugger();
export default appDebugger;
